import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';

const Account = () => {
  const {changePassword, user} = useAuth();
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (!currentPassword || !newPassword || !confirmPassword) {
      setError('Please complete all fields.');
      return;
    }

    if (newPassword !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }

    setLoading(true);
    try {
      await changePassword(currentPassword, newPassword, confirmPassword);
      setSuccess('Password updated successfully.');
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
    } catch (err) {
      setError(err.message || 'Failed to update password.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page">
      <div className="page-header">
        <div>
          <h1>Account</h1>
          <p>Email: {user?.email}</p>
        </div>
      </div>

      <div className="page-grid">
        <div className="card">
          <div className="card-header">
            <div>
              <p className="eyebrow">Password</p>
              <h2>Change your password</h2>
            </div>
          </div>

          <form onSubmit={handleSubmit} className="card-body">
            {error && (
                <div className="error-message mb-3"
                style={{ color: 'var(--error)', width: '95%', margin: '0 auto', textAlign: 'center' }}
                >
                {error}
                </div>
            )}
            {success && (
                <div className="success-message mb-3"
                style={{ color: 'var(--success)', width: '95%', margin: '0 auto', textAlign: 'center' }}
                >
                {success}
                </div>
            )}
            <div className="form-group mb-3">
              <label htmlFor="currentPassword" className="mb-1">Current Password</label>
              <input
                id="currentPassword"
                type="password"
                className="form-input"
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
                placeholder="Enter current password"
                autoComplete="current-password"
                required
              />
            </div>

            <div className="form-group mb-3">
              <label htmlFor="newPassword" className="mb-1">New Password</label>
              <input
                id="newPassword"
                type="password"
                className="form-input"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                placeholder="Enter new password"
                autoComplete="new-password"
                required
              />
            </div>

            <div className="form-group mb-4">
              <label htmlFor="confirmPassword" className="mb-1">Confirm New Password</label>
              <input
                id="confirmPassword"
                type="password"
                className="form-input"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="Confirm new password"
                autoComplete="new-password"
                required
              />
            </div>

            <button
              type="submit"
              className="btn btn-primary"
              style={{background: 'var(--primary-color)', color: 'var(--secondary-color)' }}
              disabled={loading}
            >
              {loading ? 'Updating...' : 'Update Password'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Account;

